import client from './client';

const PLAYGROUND_BASE_PATH = '/api/v1/playground';

export async function runPlayground(payload = {}) {
  const {
    communications,
    max_parallel_batches,
    batch_size_for_single_task,
    config_file_id,
  } = payload;

  const res = await client.post(
    `${PLAYGROUND_BASE_PATH}/run`,
    { communications },
    {
      params: {
        max_parallel_batches,
        batch_size_for_single_task,
        config_file_id,
      },
    },
  );
  return res.data;
}

export async function listPlaygroundTasks({ limit = 50, offset = 0, status } = {}) {
  const res = await client.get(`${PLAYGROUND_BASE_PATH}/tasks`, {
    params: {
      limit,
      offset,
      status,
    },
  });
  return res.data;
}

export async function getPlaygroundTask(taskId) {
  const res = await client.get(`${PLAYGROUND_BASE_PATH}/tasks/${taskId}`);
  return res.data;
}

export async function deletePlaygroundTask(taskId) {
  await client.delete(`${PLAYGROUND_BASE_PATH}/tasks/${taskId}`);
}

export async function getPlaygroundTaskStatus(taskId) {
  const res = await getPlaygroundTask(taskId);
  return res;
}

export async function getPlaygroundResults(taskId) {
  const res = await client.get(`${PLAYGROUND_BASE_PATH}/results/${taskId}`);
  return res.data;
}
